import React from 'react';
import * as ReactRedux from 'react-redux';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { duplicateTemplate } from 'SelfServeBuilder/SelfServeBuilderActions';
import { SecondaryButton } from 'DesignSystem/Buttons';
import { DuplicateIcon } from 'DesignSystem/Icons';
import classnames from 'classnames';

export const TemplateDuplicationButton = (props) => {
  const duplicate = async () => {
    try {
      window._track('Duplicate Template', 'Template Builder');
      const duplicateDocumentType = await props.duplicateTemplate(props.documentType);
      const redirectUrl = `/self-serve-builder?documentType=${duplicateDocumentType}&duplicate_template=1`;
      window.location.assign(redirectUrl);
    } catch (e) {
      if (props.errorCallback) {
        props.errorCallback();
      }
    }
  };

  const buttonClassNames = classnames(
    'self-serve-builder-post-share-duplicate-button',
    props.additionalClassNames,
  );

  return (
    <SecondaryButton
      className={buttonClassNames}
      onClick={duplicate}
      size="md"
      icon={<DuplicateIcon />}
    >
      Duplicate
    </SecondaryButton>
  );
};

TemplateDuplicationButton.defaultProps = {
  additionalClassNames: '',
  documentType: '',
  errorCallback: null,
};

TemplateDuplicationButton.propTypes = {
  additionalClassNames: PropTypes.string,
  documentType: PropTypes.string,
  duplicateTemplate: PropTypes.func.isRequired,
  errorCallback: PropTypes.func,
};

const mapDispatchToProps = dispatch => (
  bindActionCreators({
    duplicateTemplate,
  }, dispatch)
);

const TemplateDuplicationButtonWithRedux = ReactRedux.connect(
  null,
  mapDispatchToProps,
)(TemplateDuplicationButton);

export default TemplateDuplicationButtonWithRedux;



// WEBPACK FOOTER //
// ./src-react/SelfServeBuilder/TemplateDuplicationButton.jsx